module.exports = __webpack_public_path__ + "img/beijingtu (3).769f8eeb.png";